import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

import NavBar from "../../../components/NavBar";
import styles from "../styles/Dashboard.module.css";

import { tokenIsValid } from "../../../utils/token";
import { NavigateRoutes } from "../../../constants/routes";

const Dashboard = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["token"]);
  const [authorized, setAuthorized] = useState(false);
  const [pageDoneLoading, setPageDoneLoading] = useState(false);

  useEffect(() => {
    if (!cookies["token"] || !tokenIsValid(cookies["token"])) {
      navigate(NavigateRoutes.LOGIN);
    } else {
      setAuthorized(true);
    }
    setPageDoneLoading(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <NavBar />
      {pageDoneLoading && authorized && (
        <Container>
          <Container className={styles.homeBtnContainer}>
            <Button variant="dark" className={styles.largeButton}>
              Schedule training
            </Button>
            <div className={styles.divider} />
            <Button variant="dark" className={styles.largeButton}>
              Schedule a visit
            </Button>
            <div className={styles.divider} />
            <Button
              variant="dark"
              className={styles.largeButton}
              onClick={() => navigate(NavigateRoutes.SCHEDULER_NEW_INTERVIEW)}
            >
              RA Interview
            </Button>
          </Container>
        </Container>
      )}
    </div>
  );
};

export default Dashboard;
